/**
 * Adds data-content-name to download links inside RichText content
 * that don't already have the attribute (server-rendered templates
 * set it; this covers manually-created RichText links).
 *
 * Uses a MutationObserver so it also catches links injected by
 * Vue's v-html after SPA navigation.
 */

const DOWNLOAD_PATH = '/content/download/';

function tagDownloadLinks(root) {
  const links = (root || document).querySelectorAll(
    `a[href*="${DOWNLOAD_PATH}"]:not([data-content-name])`
  );

  links.forEach(function (link) {
    var name = link.textContent.trim();

    if (!name) {
      // Fallback: extract filename from URL
      name = link.getAttribute('href')
        .replace(/^.*\/content\/download\/\d+\/file\//, '')
        .split('?')[0]
        .split('#')[0];
    }

    if (name) {
      link.setAttribute('data-content-name', name);
    }
  });
}

export default function initDownloadTracking() {
  // Process existing links
  tagDownloadLinks();

  // Watch for dynamically rendered content (v-html, SPA navigation)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) {
          tagDownloadLinks(added[j]);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
